// Registro centrale dei testi modificabili dall'admin (usato dal pannello "Aspetto & Contenuti").
// Ogni slot corrisponde a un EditableText nelle pagine pubbliche con lo stesso slot e default.
export const CONTENT_GROUPS = [
  {
    group: "Intestazione & Brand",
    items: [
      { slot: "brand_name", label: "Nome sito (parte chiara)", default: "OPES" },
      { slot: "brand_name_accent", label: "Nome sito (parte oro)", default: "Ginnastiche" },
      { slot: "brand_slogan", label: "Slogan sotto il nome", default: "Risorse che generano valore" },
    ],
  },
  {
    group: "Menu di navigazione",
    items: [
      { slot: "nav_chi_siamo", label: "Voce menu: Chi Siamo", default: "Chi Siamo" },
      { slot: "nav_contatti", label: "Voce menu: Contatti", default: "Contatti" },
    ],
  },
  {
    group: "Home — Sezione principale (Hero)",
    items: [
      { slot: "home_hero_overline", label: "Sopratitolo", default: "Ginnastica Artistica & Ritmica" },
      { slot: "home_hero_title", label: "Titolo (parte chiara)", default: "Risorse che generano" },
      { slot: "home_hero_title_accent", label: "Titolo (parte oro)", default: "valore" },
      { slot: "home_hero_desc", label: "Descrizione", default: "Trasformiamo l'organizzazione delle competizioni in valore concreto: calendario, iscrizioni, musiche, giudizi e classifiche in un'unica piattaforma elegante, al servizio di atleti, società e giudici.", multiline: true },
      { slot: "home_hero_cta", label: "Pulsante principale", default: "Inizia ora" },
      { slot: "home_hero_cta2", label: "Pulsante secondario", default: "Accedi" },
    ],
  },
  {
    group: "Home — Altre sezioni",
    items: [
      { slot: "home_features_title", label: "Titolo sezione funzionalità", default: "Tutto ciò che serve per la competizione" },
      { slot: "home_news_overline", label: "Notizie: sopratitolo", default: "Aggiornamenti" },
      { slot: "home_news_title", label: "Notizie: titolo", default: "Notizie & Eventi" },
      { slot: "home_newsletter_title", label: "Newsletter: titolo", default: "Resta aggiornato" },
      { slot: "home_newsletter_desc", label: "Newsletter: descrizione", default: "Iscriviti alla newsletter per ricevere le novità su gare ed eventi organizzati. Ti basta inserire nome ed email.", multiline: true },
    ],
  },
  {
    group: "Footer",
    items: [
      { slot: "footer_copyright", label: "Testo copyright", default: "© 2026 OPES Settore Ginnastiche — Ginnastica Artistica & Ritmica" },
    ],
  },
  {
    group: "Home — Card Discipline",
    items: [
      { slot: "home_disc_artistica_tag", label: "Artistica: etichetta", default: "Disciplina" },
      { slot: "home_disc_artistica_title", label: "Artistica: titolo", default: "Ginnastica Artistica" },
      { slot: "home_disc_artistica_desc", label: "Artistica: descrizione", default: "Attrezzi, forza e precisione tecnica." },
      { slot: "home_disc_ritmica_tag", label: "Ritmica: etichetta", default: "Disciplina" },
      { slot: "home_disc_ritmica_title", label: "Ritmica: titolo", default: "Ginnastica Ritmica" },
      { slot: "home_disc_ritmica_desc", label: "Ritmica: descrizione", default: "Nastro, cerchio, palla ed espressività." },
    ],
  },
  {
    group: "Home — Card Funzionalità",
    items: [
      { slot: "home_feature_calendario_title", label: "Calendario: titolo", default: "Calendario Eventi" },
      { slot: "home_feature_calendario_desc", label: "Calendario: descrizione", default: "Programma gare e manifestazioni con date, sede e disciplina.", multiline: true },
      { slot: "home_feature_iscrizioni_title", label: "Iscrizioni: titolo", default: "Iscrizioni Atleti" },
      { slot: "home_feature_iscrizioni_desc", label: "Iscrizioni: descrizione", default: "Raccogli i dati dei partecipanti e le tracce musicali delle esibizioni.", multiline: true },
      { slot: "home_feature_programma_title", label: "Programma: titolo", default: "Programma di Lavoro" },
      { slot: "home_feature_programma_desc", label: "Programma: descrizione", default: "Genera l'ordine di esibizione con nomi e musiche pronto per la gara.", multiline: true },
      { slot: "home_feature_giudici_title", label: "Giudici: titolo", default: "Area Giudici" },
      { slot: "home_feature_giudici_desc", label: "Giudici: descrizione", default: "Inserimento punteggi con somma automatica di difficoltà ed esecuzione.", multiline: true },
      { slot: "home_feature_classifica_title", label: "Classifiche: titolo", default: "Classifiche Live" },
      { slot: "home_feature_classifica_desc", label: "Classifiche: descrizione", default: "Ranking automatici dal punteggio più alto al più basso, per categoria.", multiline: true },
    ],
  },
  {
    group: "Pagine Discipline (intestazione)",
    items: [
      { slot: "disc_artistica_overline", label: "Artistica: sopratitolo", default: "Disciplina" },
      { slot: "disc_artistica_title", label: "Artistica: titolo", default: "Ginnastica Artistica" },
      { slot: "disc_artistica_tag", label: "Artistica: sottotitolo", default: "Attrezzi, forza e precisione tecnica" },
      { slot: "disc_ritmica_overline", label: "Ritmica: sopratitolo", default: "Disciplina" },
      { slot: "disc_ritmica_title", label: "Ritmica: titolo", default: "Ginnastica Ritmica" },
      { slot: "disc_ritmica_tag", label: "Ritmica: sottotitolo", default: "Nastro, cerchio, palla ed espressività" },
    ],
  },
  {
    group: "Pagine Chi Siamo / Contatti (intestazione)",
    items: [
      { slot: "page_chi-siamo_overline", label: "Chi Siamo: sopratitolo", default: "OPES Ginnastiche" },
      { slot: "page_chi-siamo_title", label: "Chi Siamo: titolo", default: "Chi Siamo" },
      { slot: "page_chi-siamo_tag", label: "Chi Siamo: sottotitolo", default: "La nostra associazione e i nostri valori" },
      { slot: "page_contatti_overline", label: "Contatti: sopratitolo", default: "OPES Ginnastiche" },
      { slot: "page_contatti_title", label: "Contatti: titolo", default: "Contatti" },
      { slot: "page_contatti_tag", label: "Contatti: sottotitolo", default: "Come raggiungerci e scriverci" },
    ],
  },
  {
    group: "Contatti — Recapiti",
    items: [
      { slot: "contatti_title", label: "Titolo box contatti", default: "Contatti Settore Nazionale Ginnastiche" },
      { slot: "contatti_artistica_role", label: "Artistica: ruolo", default: "Responsabile nazionale ginnastica artistica" },
      { slot: "contatti_artistica_name", label: "Artistica: nome", default: "Catia Desti" },
      { slot: "contatti_artistica_phone", label: "Artistica: telefono", default: "380 863 7541" },
      { slot: "contatti_ritmica_role", label: "Ritmica: ruolo", default: "Responsabile nazionale ginnastica ritmica" },
      { slot: "contatti_ritmica_name", label: "Ritmica: nome", default: "Anna Ianzini" },
      { slot: "contatti_ritmica_phone", label: "Ritmica: telefono", default: "331 256 3990" },
      { slot: "contatti_email", label: "Email", default: "settoreopesginnastiche@gmail.com" },
      { slot: "contatti_copyright", label: "Copyright box contatti", default: "© 2025 Settore Nazionale Opes Ginnastiche – Tutti i diritti riservati" },
    ],
  },
];
